export default {
     namespaced: true,
     state: {
          departments: []
     },
     mutations: {
         setDepartments(state, departments) {
             state.departments = departments;
         }
     },
     actions: {
     },
     getters: {
     }
 }